var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPastAuthorizations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history 1",
    clipPath: "url(#clip0_5949_21747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.9275 8.6525L10.9275 10.9025C11.1485 11.0683 11.4617 11.0235 11.6275 10.8025C11.7932 10.5815 11.7485 10.2682 11.5275 10.1025L8.75 8V3.75C8.75 3.47375 8.52625 3.25 8.25 3.25C7.97375 3.25 7.75 3.47375 7.75 3.75V8.25C7.75 8.416 7.8195 8.5655 7.9275 8.6525Z",
    fill: "#347AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.49976 0.5C4.84001 0.5 1.71476 3.1415 1.10476 6.75L0.914761 6.4675C0.760011 6.23825 0.449011 6.17775 0.219761 6.3325C-0.00948918 6.48725 -0.0699892 6.79825 0.0847608 7.0275L1.08476 8.5275C1.16701 8.6525 1.30101 8.73425 1.44976 8.75H1.49976C1.63226 8.7495 1.75901 8.6965 1.85226 8.6025L3.10226 7.3525C3.29751 7.15725 3.29751 6.84025 3.10226 6.645C2.90701 6.44975 2.59001 6.44975 2.39476 6.645L2.08476 6.9575C2.66051 3.414 5.99976 1.0085 9.54301 1.58425C13.0863 2.16 15.4923 5.499 14.9165 9.0425C14.4053 12.189 11.6875 14.5005 8.49976 14.5C6.48926 14.5365 4.58776 13.588 3.40726 11.96C3.24701 11.735 2.93476 11.6823 2.70976 11.8425C2.48476 12.0027 2.43201 12.315 2.59226 12.54C3.95926 14.433 6.16526 15.5382 8.49976 15.5C12.642 15.5 15.9998 12.1423 15.9998 8C15.9998 3.85775 12.642 0.5 8.49976 0.5Z",
    fill: "#347AF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5949_21747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastAuthorizations);
export default __webpack_public_path__ + "static/media/pastAuthorizations.3bea767455823546a67575fc041e36f7.svg";
export { ForwardRef as ReactComponent };